import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';
import { setOnsearchValues, setSearchParameters } from './globalSlice';

export const onClearGlobalSearchData = createAsyncThunk(
    "filters/onClearGlobalSearchData",
    async (_, { dispatch }) => {
        dispatch(setSearchSummary('Search Jobs here'))
        dispatch(setGlobalLocationText(''));
        dispatch(setGlobalSearchNameText(''));
        dispatch(setNameSearchText(''));
        dispatch(setLocationSearchText(''))
        dispatch(setOnsearchValues({}))
    }
);


const initialState = {
    searchNameText: '',
    searchLocationText: '',
    GlobalSearchNameText: '',
    GlobalSearchLocationText: '',
    isClearVisibleInSearch: false,
    isGlobalSearch: false,
    searchSummary: 'Search Jobs here',
    storeAppliedFilters: {},
    innerSearchname: '',
    innerSearchLocation: ''
};

const filterSeacrhSlice = createSlice({
    name: 'FilterSeacrh',
    initialState,
    reducers: {
        setNameSearchText: (state, action) => {
            state.searchNameText = action.payload
        },
        setLocationSearchText: (state, action) => {
            state.searchLocationText = action.payload
        },
        setGlobalSearchNameText: (state, action) => {
            state.GlobalSearchNameText = typeof action.payload === 'string' ? action.payload : '';
        },

        setGlobalLocationText: (state, action) => {
            state.GlobalSearchLocationText = action.payload
        },
        onClearSearchWithGlobal: (state, action) => {
            state.isClearVisibleInSearch = action.payload
        },
        setIsGlobalSearchOpen: (state, action) => {
            state.isGlobalSearch = action.payload
        },
        setSearchSummary: (state, action) => {
            state.searchSummary = action.payload
        },
        setStoreAppliedFilters: (state, action) => {
            state.storeAppliedFilters = action.payload
        },
        setInnerSearchText: (state, action) => {
            state.innerSearchname = action.payload
        },
        setInnerSearchLocation: (state, action) => {
            state.innerSearchLocation = action.payload
        }
    }
});

export const
    { setNameSearchText, setLocationSearchText, setGlobalLocationText, setGlobalSearchNameText,
        onClearSearchWithGlobal, setIsGlobalSearchOpen, setSearchSummary, setStoreAppliedFilters, setInnerSearchLocation, setInnerSearchText } = filterSeacrhSlice.actions;
export default filterSeacrhSlice.reducer;
